import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  WalletTransferInfo,
  WalletTransferStatus,
} from 'wallet-transfer/services/wallet-transfer-service';

import { RootState } from '../store';

export interface WalletTransferState {
  walletTransferInfo: WalletTransferInfo;
}

const initialState: WalletTransferState = {
  walletTransferInfo: {
    status: WalletTransferStatus.EXPIRED,
    sourceName: '',
    amount: 0,
    currency: '',
    targetMobileNumber: '',
    createdAt: '',
    comment: '',
    country: '',
    sourceProfilePicture: '',
    targetCountry: '',
  },
};

export const walletTransferSlice = createSlice({
  name: 'wallet-transfer',
  initialState,
  reducers: {
    resetStore: (state) => {
      state = initialState;
      return state;
    },
    setWalletTransferDetails: (state, action: PayloadAction<WalletTransferInfo>) => {
      state.walletTransferInfo = action.payload;
    },
  },
});

// Selectors
const getWalletTransferState = (state: RootState): WalletTransferState => state.walletTransfer;

export const getWalletTransferDetails = createSelector(
  getWalletTransferState,
  (walletTransfer) => walletTransfer.walletTransferInfo,
);

const { actions, reducer } = walletTransferSlice;

export const { setWalletTransferDetails, resetStore: walletTRansferResetStore } = actions;

export default reducer;
